module.exports = __webpack_public_path__ + "img/playStore.1a03e135.png";